module.exports = __webpack_public_path__ + "static/assets/f546923e2c2d53c58bbfcb56caefcd42.png";